import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import EpicSubmitButton from '../EpicSubmitButton/epic.submit.button.vue';
import * as T_T from 'cryface';
import { NoticeConfig } from 'iview';
import { CommonConfig } from '../../configs/config.common';
import { AxiosPromise } from '../..//utils/axios.promise';
import EpicTabChild from '../EpicTabChild/epic.tab.child.vue';
import EpicTabPanel from '../EpicTabPanel/epic.tab.panel.vue';
import { RegisterValidate } from './register.validator';

@Component({
    components: {
        EpicSubmitButton,
        EpicTabPanel,
        EpicTabChild,
    }
})
export default class EpicSignInCard extends Vue {
    public title: string = 'EpicSignInCard';

    public config: CommonConfig = new CommonConfig();

    public isSignIn = false;

    public isRegistering = false;

    public formItem = {
        username: '',
        password: '',
    };

    public registerFormItems = {
        email: '',
        password: '',
        passwordAlt: '',
    };

    @Prop({ default: undefined })
    public data: any;

    @Watch('data', { immediate: true, deep: true })
    public onDataInput(val: any, oldVal: any) {
    }

    public handleCloseButton() {
        this.$store.commit('bgBlurOff');
    }

    public async handleSignIn() {
        if (T_T.simpleDetect(this.formItem.username) && T_T.simpleDetect(this.formItem.password)) {
            this.isSignIn = true;
            await this.getUserC();
        } else {
            alert('Username Or Password Can Not Be Empty');
        }
    }

    public async handleRegister() {
        const validateRes = RegisterValidate.validate(this.registerFormItems);
        if (validateRes !== 'validated') {
            alert(validateRes);
        } else {
            this.isRegistering = true;
            const apiHost = this.config.cmisapiHost;
            const body = {
                keyword: this.registerFormItems.email,
                password: this.registerFormItems.password,
                type: 1,
                ltype: 0,
                comfirmPassword: this.registerFormItems.passwordAlt,
                countryId: 38,
            };
            const fetched: any = await AxiosPromise.postJson(`${apiHost}/regis/rgs`, body);
            this.isRegistering = false;
            if (fetched.status === 200) {
                const data = fetched.data;
                if (data.code === 300) {
                    alert('Email Has Been Used. Please Feel Free To Contact Us, If There Is Any Question.');
                } else if (data.code === 200) {
                    alert('Registration Succeed.');
                    this.$store.commit('bgBlurOff');
                }
            }
        }
    }

    public async getUserC() {
        const apiHost = this.config.cmisapiHost;
        const body = {
            keyword: this.formItem.username,
            password: this.formItem.password,
            ltype: 0,
        };
        const userC = await AxiosPromise.postJson(`${apiHost}/login/signin`, body);
        if (userC.data.code === 200) {
            this.$store.commit('setClientCLogin', userC.data.data);
            const _this: any = this;
            const browserStore: any = _this.$browserStore;
            browserStore.setSession('Swap', JSON.stringify(userC.data.data));
            const successNoticeConfig: NoticeConfig = {
                title: 'Sign In Succeed',
                desc: '',
            };
            this.$Notice.info(successNoticeConfig);
            this.$store.commit('bgBlurOff');
            this.isSignIn = false;
        } else {
            const successNoticeConfig: NoticeConfig = {
                title: 'Sign In Failed',
                desc: 'Invalid Username Or Password',
            };
            this.$Notice.error(successNoticeConfig);
            this.isSignIn = false;
        }
    }
}
